<template>
    <true-panel class="inlineAdvice scrollToItem"
                :class="{'expanded': expanded}">
        <div class="clickable main-clickable" v-show="!expanded && expandable" @click="toggleExpanded"></div>
        <div class="inlineAdviceLabel">
            <span class="true">true</span>security advice
        </div>
        <div class="inlineAdviceTitle">
            <slot name="title" />
            <div class="inlineAdviceExpander"
                 v-if="expandable"
                 @click="toggleExpanded">
                <img class="expander-chevron"
                     src="/img/chevron-down-gray.png"
                     alt="Down arrow">
            </div>
        </div>
        <div class="inlineAdviceExpandedContent"
             v-if="expanded">
            <div class="inlineAdviceText">
                <slot name="text" />
            </div>
            <slot />
            <div class="inlineAdviceAction" v-if="hasActionSlot">
                <slot name="action" />
            </div>
        </div>
    </true-panel>
</template>



<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    expand: {
      type: Boolean,
      default: true
    },
    expandable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expanded: true
    };
  },
  computed: {
    ...mapState([]),
    hasActionSlot() {
      return this.$slots["action"];
    }
  },
  methods: {
    ...mapActions([]),

    toggleExpanded() {
      this.expanded = !this.expanded;
    }
  },
  mounted() {
    this.expanded = this.expand;
  }
};
</script>


<style lang="css"></style>
